import {React, useState} from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { jsondata } from '../schools';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AdvisorReccomendInput(props) {
    const [value, setValue] = useState();


  return (
    <Autocomplete
    value={value}
    fullWidth
    onChange={(event, newValue) => {
        setValue(newValue);
      props.reccomend(newValue);
    }}

    id="controllable-states-demo"
    options={options}
    renderInput={(params) => <TextField {...params} label="Reccomend?" />

    }
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const options = ["Yes", "No", "Maybe"];